import { render } from "./PageOAuthConsent.vue?vue&type=template&id=fc4ebff4"
import script from "./PageOAuthConsent.vue?vue&type=script&lang=js"
export * from "./PageOAuthConsent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__